var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonePopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#50BD89"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4489_28355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8001 13.6799L9.40014 12.2799C9.24414 12.1239 8.99614 12.1239 8.84014 12.2799C8.68414 12.4359 8.68414 12.6839 8.84014 12.8399L10.5161 14.5159C10.6721 14.6719 10.9241 14.6719 11.0801 14.5159L15.3201 10.2799C15.4761 10.1239 15.4761 9.87591 15.3201 9.71991C15.1641 9.56391 14.9161 9.56391 14.7601 9.71991L10.8001 13.6799Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4489_28355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 9.6,
    fill: "white",
    transform: "translate(7.2002 7.19995)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonePopup);
export default __webpack_public_path__ + "static/media/donePopup.873f9db0.svg";
export { ForwardRef as ReactComponent };